<template>
  <div class="room-rates">
    <div class="rate-list" :class="{ 'single-item': !moreThanOneRate }">
      <rate-item
          :rate="preferredRoomRate"
          :room="room"
          :bed-type="bedType"
          @select="selectedRate = $event"
          @continue="keepRate"
      />
      <div clas="collapsible-rates" v-show="isShow">
        <rate-item
            v-for="(rate, index) in additionalRoomRates"
            :key="'rate' + index"
            :rate="rate"
            :room="room"
            :bed-type="bedType"
            @select="selectedRate = $event"
            @continue="keepRate"
        />
      </div>
      <button class="rate-list-cta"
              v-if="moreThanOneRate"
              :class="{ 'open': isShow }"
              v-bind:aria-expanded="isShow ? 'true' : 'false'"
              v-on:click.prevent="toggleRateList"
              v-on:enter="toggleRateList"
              v-on:keydown.space.prevent="toggleRateList"
      >
        {{ !isShow ? tc('booking.seeMoreRates') : tc('booking.seeFewerRates')}}
      </button>
    </div>
      <transition name="slide-right">
        <rate-details
            v-if="selectedRate"
            :rate="selectedRate"
            :room="room"
            :bed-type="bedType"
            @close="selectedRate = null"
            @continue="keepRate"
        />
      </transition>
      <transition name="fade">
        <div
            v-if="selectedRate"
            class="backlight"
            @click="selectedRate = null"
        ></div>
      </transition>
  </div>
</template>

<script>
import RateItem from '../components/rate-item'
import RateDetails from '../components/rate-details'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'rate-list',
  components: {
    RateItem,
    RateDetails
  },
  props: {
    room: {
      type: Object,
      required: true
    },
    bedType: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    selectedRate: null,
    isShow: false
  }),
  watch: {
    room() {
      this.isShow = false
    }
  },
  computed: {
    ...mapGetters('i18n', ['tc']),
    preferredRateId() {
      return this.room.preferredRate
    },
    roomRates() {
      return this.room.rates.filter(r => r.roomTypeCode === this.bedType.synXisID)
    },
    preferredRoomRate() {
      const preferredRate = this.room.rates.filter(r => r.roomTypeCode === this.bedType.synXisID && r.synXisID === this.preferredRateId)
      return preferredRate[0] || this.roomRates[0]
    },
    additionalRoomRates() {
      return this.roomRates.filter((value) => JSON.stringify(value) !== JSON.stringify(this.preferredRoomRate))
    },
    moreThanOneRate() {
      return this.roomRates.length > 1
    }
  },
  methods: {
    ...mapActions('booking', ['validateRoute']),
    keepRate() {
      this.validateRoute()
    },
    toggleRateList() {
      if (this.isShow) this.$parent.$el.scrollIntoView({
        behavior: 'smooth'
      })
      this.isShow = !this.isShow
    }
  }
}
</script>
